import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import DeleteModal from '@components/DeleteModal';
import NoData from '@components/NoData';
import { toastError, toastSuccess } from '@components/Toast';

import Fabric from '@features/materials/components/Fabric';
import MaterialCardItemView from '@features/materials/components/MaterialCardItemView';
import MaterialInventory from '@features/materials/components/MaterialInventory';
import DownloadSticker from '@features/supplier/component/DownloadSticker';

import { fetchFavouriteMaterials } from '@store/favourite/actions';
import { unlikeMaterial } from '@store/material/action';

import ApiClient from '@lib/apiClient';

import { FAVOURITES, getConsumptionUnit, isFabric, VIEW_TYPE_OBJ } from '@utils/MaterialsUtil';
import { isPageReachBottom } from '@utils/Util';

import { MATERIALS_TYPE } from '@/constants/constant';

const MaterialFavourite = ({
	isLoading,
	setIsLoading,
	materialsDataList,
	setMaterialsDataList,
	materialsData,
	search = '',
	selectedMaterialIdList,
	setSelectedMaterialIdList,
	setAllFavouritesForMaterials
}) => {
	const [viewType, setViewType] = useState('');
	const [selectedItem, setSelectedItem] = useState(null);
	const [isEdit, setIsEdit] = useState('');
	const [selectedMaterialList, setSelectedMaterialList] = useState([]);
	const [isAllCheckedButtonClicked, setIsAllCheckedButtonClicked] = useState(false);
	const [isInventoryModal, setIsInventoryModal] = useState(false);
	const [remove, setRemove] = useState(false);
	const [page, setPage] = useState(0);
	const [isAdd, setIsAdd] = useState('');
	const [consumptionUnit, setConsumptionUnit] = useState('');
	const [selectedMaterialListForSticker, setSelectedMaterialListForSticker] = useState([]);

	const dispatch = useDispatch();
	const elementRef = useRef(null);
	const scrollRef = useRef({});
	const setCurrentState = (data) => {
		scrollRef.current = data;
	};
	useEffect(() => {
		setCurrentState(materialsData);
		setMaterialsDataList(materialsData);
		// if (isAllCheckedButtonClicked) {
		// 	let materialIds = materialsData?.data?.map((item) => item.materialId);
		// 	setSelectedMaterialIdList(materialIds);
		// 	setSelectedMaterialList(materialsData?.data);
		// }
	}, [materialsData]);

	useEffect(() => {
		if (page != 0) {
			favouriteMaterialApiCalling();
		}
	}, [page]);

	const favouriteMaterialApiCalling = async () => {
		setIsLoading(true);
		await dispatch(fetchFavouriteMaterials(page, 30)).finally(() => {
			setIsLoading(false);
		});
	};
	const handleScroll = () => {
		if (isPageReachBottom()) {
			let { hasNext } = scrollRef.current;
			if (hasNext && !isLoading) {
				setPage((page) => page + 1);
			}
		}
	};
	useEffect(() => {
		document.addEventListener('scroll', handleScroll);
		return () => {
			document.removeEventListener('scroll', handleScroll);
		};
	}, []);

	const onMaterialClick = (item, activeStep) => {
		let url = `/materials/view/${item?.materialId}?type=${activeStep}`;
		window.open(url, '_blank');
		// returnnavigate(url);
	};
	const onEdit = (e, item, viewType) => {
		item.id = item.materialId;
		setViewType(viewType);
		setSelectedItem(item);
		setIsEdit('FABRIC');
		e.stopPropagation();
	};

	// const handleSelectAllMaterial = (e) => {
	// 	if (e.target.checked) {
	// 		let materialIds = materialsData?.data?.map((item) => item.materialId);
	// 		setSelectedMaterialIdList(materialIds);
	// 		setSelectedMaterialList(materialsData?.data);
	// 		setIsAllCheckedButtonClicked(true);
	// 		fetchFavouriteMaterialsForAllSticker(search, setSelectedMaterialListForSticker, setIsLoading);
	// 	} else {
	// 		setSelectedMaterialIdList([]);
	// 		setSelectedMaterialList([]);
	// 		setIsAllCheckedButtonClicked(false);
	// 	}
	// };

	const handleMaterialSelection = (e, materialId) => {
		if (selectedMaterialIdList.includes(materialId)) {
			setSelectedMaterialIdList((prev) => prev.filter((item) => item !== materialId));
			setSelectedMaterialList((prev) => prev.filter((item) => item.materialId !== materialId));
		} else {
			setSelectedMaterialIdList((prev) => [...prev, materialId]);

			let data = materialsDataList?.data?.find((item) => item.materialId === materialId);
			setSelectedMaterialList((prev) => [...prev, data]);
		}
	};

	const inventoryModalOpen = (e, item) => {
		item.id = item.materialId;
		setSelectedItem(item);
		let materialType = item?.materialType?.toUpperCase();
		if (isFabric(materialType.toUpperCase())) {
			setConsumptionUnit(getConsumptionUnit(item));
		} else if ([MATERIALS_TYPE.TRIMS, MATERIALS_TYPE.BRANDING].includes(materialType)) {
			setConsumptionUnit(item?.trimsAndBrandingTableResponse?.subCategoryType?.consumptionUnit);
		}
		setIsInventoryModal(true);
		e.stopPropagation();
	};

	const onclose = async (value) => {
		if (value !== undefined && value !== 'Cancel') await favouriteMaterialApiCalling();
		setIsAdd('');
		setIsEdit('');
		setViewType('');
		setSelectedItem(null);
		setIsInventoryModal(false);
	};

	const onExpired = async (e, item) => {
		e.stopPropagation();
		setIsLoading(true);
		await ApiClient.PUT(
			'updatedMaterialByMaterialIdAndIsExpired',
			null,
			item.materialId + '/' + !item?.isExpired
		)
			.then(() => {
				favouriteMaterialApiCalling();
			})
			.catch(({ response }) => {
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	const onLikeMaterial = async () => {
		// onSetLikeAndUnlike(id, true);
		// let response = await dispatch(likeMaterial(id));
		// if (!response) {
		// 	onSetLikeAndUnlike(id, false);
		// }
	};

	const onUnlikeMaterial = async (id) => {
		setIsLoading(true);
		let response = await dispatch(unlikeMaterial(id));
		setIsLoading(false);
		if (response) {
			let tempMaterialList = materialsDataList?.data?.filter((item) => item.materialId !== id);
			materialsDataList.data = tempMaterialList;
			setMaterialsDataList({
				...materialsDataList
			});
			let tempMaterialIdList = selectedMaterialIdList.filter((materialId) => materialId !== id);
			setSelectedMaterialIdList([...tempMaterialIdList]);
			favouriteMaterialApiCalling();
		}
	};

	const handleClose = () => {
		setRemove(false);
	};

	const onRemove = async () => {
		setIsLoading(true);
		await ApiClient.DELETE('materialAction', {}, selectedItem.materialId)
			.then(({ data }) => {
				setIsLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					favouriteMaterialApiCalling().finally(() => {});
					handleClose();
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				handleClose();
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const generateStickerObj = () => {
		let obj = {};
		obj.supplierType = 'FABRIC';
		if (search.trim() !== '') obj.search = search;
		return obj;
	};

	const selectItemGenerateStickerObj = () => {
		return {
			supplierType: 'FABRIC',
			materialIdList: selectedMaterialIdList
		};
	};

	return (
		<div className="body-content bg-white">
			<div className="data-table scroll-x-label" ref={elementRef}>
				<div className="filter-container-top favorites-filter-top pb-3 pt-0 pl-0">
					<div className="all-checkbox bg-gray-light select-all-designs">
						<div className="custom-chekbox"></div>
					</div>
				</div>

				<div className="fabric-list-container">
					{materialsDataList?.data?.length === 0 ? (
						<div className="no-favorite">
							<NoData message={'No favourite added yet'} />
						</div>
					) : (
						<MaterialCardItemView
							materialsData={materialsDataList}
							activeStep={'FABRIC'}
							onMaterialClick={onMaterialClick}
							onEdit={onEdit}
							selectedMaterialIdList={selectedMaterialIdList}
							setSelectedItem={setSelectedItem}
							handleMaterialSelection={handleMaterialSelection}
							inventoryModalOpen={inventoryModalOpen}
							isAllCheckedButtonClicked={isAllCheckedButtonClicked}
							onExpired={onExpired}
							setRemove={setRemove}
							defaultViewType={VIEW_TYPE_OBJ.MATERIAL_LIST.name}
							onLikeMaterial={onLikeMaterial}
							onUnlikeMaterial={onUnlikeMaterial}
							cardModelName={FAVOURITES}
						/>
					)}
					{isEdit === 'FABRIC' && (
						<Fabric
							materialData={selectedItem}
							isShow={true}
							onclose={onclose}
							viewType={viewType}
							renderFrom={'MATERIAL'}
							isAdd={isAdd === 'FABRIC'}
						/>
					)}
					{isInventoryModal && (
						<MaterialInventory
							materialData={selectedItem}
							onclose={onclose}
							viewType={viewType}
							consumptionUnit={consumptionUnit}
						/>
					)}
					<DownloadSticker
						callback={() => setIsAllCheckedButtonClicked(false)}
						selectedMaterialIdList={selectedMaterialIdList}
						setSelectedMaterialIdList={setSelectedMaterialIdList}
						params={{
							supplierType: 'FABRIC',
							materialIdList: selectedMaterialIdList
						}}
						count={selectedMaterialIdList?.length}
						selectedMaterialList={selectedMaterialList}
						setSelectedMaterialList={setSelectedMaterialList}
						stickerModelName={FAVOURITES}
						object={
							isAllCheckedButtonClicked ? generateStickerObj() : selectItemGenerateStickerObj()
						}
						selectedMaterialListForSticker={
							isAllCheckedButtonClicked ? selectedMaterialListForSticker : selectedMaterialList
						}
						setSelectedMaterialListForSticker={setSelectedMaterialListForSticker}
						parentComponent={'FAVOURITE_MATERIAL'}
						materialResponse={materialsDataList}
						favouriteMaterialApiCalling={favouriteMaterialApiCalling}
						setMaterialsDataList={setMaterialsDataList}
						setAllFavouritesForMaterials={setAllFavouritesForMaterials}
					/>
					{remove && <DeleteModal onRemove={onRemove} onClose={handleClose} />}
				</div>
			</div>
		</div>
	);
};
export default MaterialFavourite;
